import {
  getBrowserDistinctId,
  groupBrowserAnalytics,
  identifyBrowserActor,
} from "@workspace/analytics/browser";
import {
  buildAnalyticsGroupProperties,
  buildAnalyticsIdentityProperties,
} from "@workspace/analytics/privacy";
import { useSession } from "next-auth/react";
import { useEffect, useRef } from "react";
import type { ExtendedUser } from "@/auth";

export function usePostHogIdentify() {
  const { data: session, status } = useSession();
  const lastPropsHashRef = useRef<string | null>(null);

  useEffect(() => {
    if (status === "unauthenticated") {
      lastPropsHashRef.current = null;
      return;
    }

    if (status !== "authenticated" || !session?.user) {
      return;
    }

    const user = session.user as ExtendedUser;
    const properties = buildAnalyticsIdentityProperties(user);
    const organizationId = user.organization;
    const propsHash = JSON.stringify(properties);
    const groupProps = organizationId
      ? buildAnalyticsGroupProperties({
          id: organizationId,
          type: user.type,
        })
      : null;
    const groupHash = groupProps ? JSON.stringify(groupProps) : null;
    const identityHash = JSON.stringify({ propsHash, groupHash });

    const alreadyIdentified =
      getBrowserDistinctId() === user.id &&
      lastPropsHashRef.current === identityHash;

    if (alreadyIdentified) {
      return;
    }

    identifyBrowserActor(user.id, properties);
    if (organizationId) {
      groupBrowserAnalytics("organization", organizationId, groupProps ?? {});
    }
    lastPropsHashRef.current = identityHash;
  }, [status, session]);
}
